/** Bass grooves and arpeggio rhythms the songs share (notation in types.ts). Pure data. */

/** Root, octave, fifth, octave in eighths and no drums: the arcade oom-pah. */
export const HOP = 'R . O . F . O . R . O . F . O .';
/** Octave-jumping bass with the snare on the backbeat: the bounce. */
export const BOUNCE = 'R . O . S . O . R . O . S . O F';
/** A march, with a snare roll into the next bar. */
export const MARCH = 'R . O . S . O . R . O . S . S S';
/** The fight: kick and snare with sixteenths of root and octave pounding between them. */
export const CHARGE = 'K R O R S R O R K R O R S R O F';
/** The fight held back: long roots, the snare on two and four, a roll into the next bar. */
export const STOMP = 'R . . . S . . . R . . . S . S S';

/** 3 + 3 + 2: the broken chord starts again where a tune would skip. */
export const TRESILLO = 'x . . x . . x . x . . x . . x .';
/** Two notes of the chord on every offbeat, the beats left empty. */
export const OFFBEAT = '- . x . - . x . - . x . - . x .';
/** No chords at all. */
export const TACET = '- . . . . . . . . . . . . . . .';
